define('shared/initializer/form/newHouseAdapters/Upsell',[
    '../adapters/Upsell'
],
function (
    UpsellAdapter
) {
    return UpsellAdapter;
});
